module.exports = __webpack_public_path__ + "static/media/wallet-inkomoko.ab53921e.svg";